import { render, staticRenderFns } from "./ProjectPotatoSampleFormGroup.vue?vue&type=template&id=453aa05f"
import script from "./ProjectPotatoSampleFormGroup.vue?vue&type=script&lang=js"
export * from "./ProjectPotatoSampleFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports